import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getState } from '../thunks/commonInfoThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'state';

export const stateSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getState });
    },
});

export const state = stateSlice.reducer;
